module.exports = __webpack_public_path__ + "static/media/bts.001e53c2.png";